import BasicAutoQueryController from "servicestack/auto-query/auto-query.controller";
import openProductPicker from "emun.products/picker/product-picker";
import PartsOrderPrompt from "emun.order/parts/parts-order-prompt";
import config from "emun.order/order.config";

export const views = {
  list: "th-list",
  cards: "th"
};

export const filters = [
  { groupBy: "Status", title: "EmunStatus", operation: "Contains" },
  { date: "CreatedOn", title: "Order Date", operation: "Contains" },
  { text: "ProductId", title: "SKU", operation: "Contains" },
  { text: "ContactName", title: "Contact", operation: "Contains" },
  { text: "TagFor", title: "Tag For", operation: "Contains" },
  { text: "InvoiceId", title: "Invoice #", operation: "Contains" },
  { text: "RetailerId", title: "Customer #", operation: "Contains" },
  { text: "PONumber", title: "PO #", operation: "Contains" }
];

export const sortOptions = {
  Id: "Id: Low to High",
  "-CreatedOn,Id": "Created On: Oldest",
  //"CreatedBy,Id": "Created By",
  "ProductId,Id": "SKU: Low to High",
  "RetailerId,Id": "Customer #: Low to High",
  "ShipToId,Id": "Ship To #: Low to High",
  "ContactName,Id": "Contact: A to Z",
  "Status,Id": "Status: A to Z",
  //"Comments,Id": "Comments",
  "PoNumber,Id": "PO#: Low to High",
  "TagFor,Id": "Tag For: A to Z",
  "Acknowledgement,Id": "Acknowledgement: A to Z",
  "InvoiceId,Id": "Invoice #: Low to High",
  "ShipToOverride,Id": "Ship To Override: A to Z",
  "CustomerServiceEmail,Id": "Customer Service Email: A to Z"
};

export default class PartsOrderContainerController extends BasicAutoQueryController {
  onOrdersLoaded(args) {
    const $ctrl = this;
    console.debug("PartsOrderContainerController.onLoaded", {
      PartsOrderContainerController: this,
      args
    });
    $ctrl.ngModel = this;
  }
  getQuery() {
    const $ctrl = this;
    return {
      url: `QueryPartsOrders.json`, //?StatusNotEqualTo=Cart',
      orderBy: "-CreatedOn,Id",
      disableQueryString: !!$ctrl.disableQueryString,
      pageSize: 12,
      criteria: {
        retailerId: $ctrl.retailerId,
        productId: $ctrl.productId
      },
      views,
      view: $ctrl.$pageConfig.is("gt-md") ? "list" : "cards",
      filters,
      hideLeftNav: true, // $ctrl.$pageConfig.is('gt-sm'),
      autoLoad: true,
      sortOptions,
      onLoaded: args => $ctrl.onOrdersLoaded(args)
    };
  }

  createOrder() {
    const $ctrl = this;
    openProductPicker({
      single: true,
      subTitle: "Create Parts Order",
      view: "table",
      criteria: {
        ProductSubstituteType: "Parts"
      }
    }).then(product =>
      PartsOrderPrompt({
        subTitle: $ctrl.$session.retailerId,
        product
      }).then(() => $ctrl.query.load())
    );
  }
  printOrder(order) {
    const $ctrl = this;
  }
  deleteOrder(order) {
    const $ctrl = this;
    return $ctrl.$modals
      .confirm(
        "Are you sure you want to delete parts order: " +
          " - Name: " +
          order.retailer.companyName +
          "?",
        "Delete Parts Order"
      )
      .result.then(function () {
        $ctrl.bus
          .send("DeletePartsOrder.json", order)
          .then(function (response) {
            $ctrl.$emit("PartsOrderDeleted", $ctrl);
            $ctrl.query.load();
          });
      });
  }
  vendorShipment(order) {
    const $ctrl = this;
  }
}
